import { Tab, Tabs } from "@mui/material";
import { ReactElement } from "react";
import { useSearchParams } from "react-router-dom";

const TABS = [
  { key: "mark", label: "Mark Attendance" },
  { key: "messages", label: "Message Status" },
] as const;

export type AttendanceTabKey = (typeof TABS)[number]["key"];

/**
 * Tabs for the Students and Staff attendance pages. The tab is kept in the URL (?tab=...), like
 * Academics → Setup. Returns the current tab and the Tabs element to put on the left of PageTopBar.
 */
export const useAttendancePageTabs = (): [AttendanceTabKey, ReactElement] => {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab");
  const tab: AttendanceTabKey = TABS.some((t) => t.key === requested) ? (requested as AttendanceTabKey) : "mark";

  const tabs = (
    <Tabs
      value={tab}
      onChange={(_, next: AttendanceTabKey) => setParams({ tab: next }, { replace: true })}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ minHeight: 40 }}
    >
      {TABS.map((t) => (
        <Tab key={t.key} value={t.key} label={t.label} sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }} />
      ))}
    </Tabs>
  );
  return [tab, tabs];
};
